import { GET } from '../request'

export const login = ({ token }) => GET('/login/profes', { token })
